import React from 'react';
import { AlertCircle, Info, CheckCircle } from 'lucide-react';
import styled from 'styled-components';
import { AlertTriangle, MessageSquare } from 'lucide-react';

export const NotificationsContainer = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`;

export const NotificationsHeader = styled.div`
  padding: 1rem;
  border-bottom: 1px solid #e5e7eb;
`;

export const NotificationsTitle = styled.h2`
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
`;

export const NotificationsList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NotificationItem = styled.div<{ type: 'alert' | 'info' | 'success' }>`
  padding: 1rem;
  display: flex;
  align-items: flex-start;
  background-color: ${({ type }) => {
    switch (type) {
      case 'alert':
        return '#fff1f2';
      case 'info':
        return '#eff6ff';
      case 'success':
        return '#f0fdf4';
      default:
        return 'white';
    }
  }};
`;

export const NotificationIconContainer = styled.div<{ type: 'alert' | 'info' | 'success' }>`
  margin-top: 0.125rem;
  margin-right: 0.75rem;
  color: ${({ type }) => {
    switch (type) {
      case 'alert':
        return '#dc2626';
      case 'info':
        return '#2563eb';
      case 'success':
        return '#16a34a';
      default:
        return '#6b7280';
    }
  }};
`;

export const NotificationContent = styled.div`
  flex: 1;
`;

export const NotificationMessage = styled.p`
  font-size: 0.875rem;
  color: #111827;
`;

export const NotificationTimestamp = styled.p`
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #6b7280;
`;

interface Notification {
  id: number;
  type: 'alert' | 'info' | 'success';
  message: string;
  time: string;
}

interface NotificationListProps {
  notifications: Notification[];
}

const NotificationList: React.FC<NotificationListProps> = ({ notifications }) => {
  console.log('NotificationList received notifications:', notifications);
  return (
    <NotificationsContainer>
      <NotificationsHeader>
        <NotificationsTitle>Notifications</NotificationsTitle>
      </NotificationsHeader>
      <NotificationsList>
        {notifications.length === 0 ? (
          <div style={{ padding: '1rem', color: '#6b7280' }}>No notifications found.</div>
        ) : (
          notifications.map((notification) => (
            <NotificationItem key={notification.id} type={notification.type}>
              <NotificationIconContainer type={notification.type}>
                {notification.type === 'alert' && <AlertTriangle size={18} />}
                {notification.type === 'info' && <MessageSquare size={18} />}
                {notification.type === 'success' && <CheckCircle size={18} />}
              </NotificationIconContainer>
              <NotificationContent>
                <NotificationMessage>{notification.message}</NotificationMessage>
                <NotificationTimestamp>{notification.time}</NotificationTimestamp>
              </NotificationContent>
            </NotificationItem>
          ))
        )}
      </NotificationsList>
    </NotificationsContainer>
  );
};

export default NotificationList; 